<div
  class="vc-calendar Calendar"
  *ngIf="this.isReady"
  [class.vc-calendar--compact]="settings.display.compactCards"
  [class.vc-calendar--dim-past]="settings.view.dimPastAppointments"
  [class.vc-calendar--hide-status-icons]="!settings.display.showStatusIcons"
  [class.vc-calendar--show-duration]="settings.display.showDuration"
  [class.vc-calendar--hide-time-indicator]="
    !settings.view.showCurrentTimeIndicator
  "
>
  <!-- Toolbar simplificado -->
  <div class="vc-calendar__toolbar" *ngIf="!isMobileView">
    <app-calendar-appointments-actions
      [onAction]="this.onAction"
      [calendar]="this.calendars"
      [quickMode]="this.quickMode"
      [view]="this.view"
      [viewDate]="this.viewDate"
      [openSettings]="this.openSettings"
    ></app-calendar-appointments-actions>
  </div>

  <app-calendar-appointments-view
    *ngIf="isMobileView"
    [calendars]="this.calendars"
    [events]="this.events"
    [locale]="this.locale"
    [viewDate]="this.viewDate"
    [view]="this.view"
    [refresh]="this.refresh"
    [dayStartHour]="getDayStartHour()"
    [dayEndHour]="getDayEndHour()"
    [precision]="this.getPrecision()"
    [settings]="this.settings"
    [openSettings]="this.openSettings"
    [onAction]="this.onAction"
    [patient]="this.patient"
    [treatments]="this.treatments"
    [quickMode]="this.quickMode"
    (eventTimesChanged)="eventTimesChanged($event)"
  ></app-calendar-appointments-view>

  <!-- Contenedor principal con navegación lateral -->
  <div class="vc-calendar__container" *ngIf="!isMobileView">
    <!-- Flecha izquierda (solo desktop) -->
    <button
      class="vc-calendar__nav-arrow vc-calendar__nav-arrow--prev"
      (click)="navigatePrevious()"
      aria-label="Período anterior"
    >
      <i class="fas fa-chevron-left"></i>
    </button>

    <!-- Área del calendario -->
    <div class="vc-calendar__grid vc-calendar-grid">
      <ng-template
        #customWeekEventTemplate
        let-weekEvent="weekEvent"
        let-tooltipPlacement="tooltipPlacement"
        let-eventClicked="eventClicked"
        let-tooltipTemplate="tooltipTemplate"
        let-tooltipAppendToBody="tooltipAppendToBody"
        let-tooltipDisabled="tooltipDisabled"
        let-tooltipDelay="tooltipDelay"
        let-column="column"
        let-daysInWeek="daysInWeek"
      >
        <div
          class="cal-event vc-event-card"
          [ngClass]="weekEvent.event.cssClass"
          [ngStyle]="{
            backgroundColor: weekEvent.event.color?.secondary,
            borderLeftColor:
              weekEvent.event.meta?.statusBorderColor ||
              weekEvent.event.color?.primary,
          }"
          [mwlCalendarTooltip]="
            !tooltipDisabled
              ? (weekEvent.event.title
                | calendarEventTitle
                  : (daysInWeek === 1 ? 'dayTooltip' : 'weekTooltip')
                  : weekEvent.tempEvent || weekEvent.event)
              : ''
          "
          [tooltipPlacement]="tooltipPlacement"
          [tooltipEvent]="weekEvent.tempEvent || weekEvent.event"
          [tooltipTemplate]="tooltipTemplate"
          [tooltipAppendToBody]="tooltipAppendToBody"
          [tooltipDelay]="tooltipDelay"
          (mwlClick)="eventClicked.emit({ sourceEvent: $event })"
          (mwlKeydownEnter)="eventClicked.emit({ sourceEvent: $event })"
          tabindex="0"
          role="application"
        >
          <!-- Header: Hora + Warning indicator -->
          <div class="vc-event-card__header">
            <span class="vc-event-card__time">
              {{ weekEvent.event.start | date: "HH:mm" }}
              <span
                *ngIf="settings.display.showDuration"
                class="vc-event-card__duration"
              >
                ({{ getEventDuration(weekEvent.event) }})
              </span>
              <span
                *ngIf="
                  weekEvent.event.meta?.warnings?.length > 0 &&
                  settings.display.showStatusIcons
                "
                class="vc-event-card__warning-dot severity-{{
                  weekEvent.event.meta?.maxSeverity
                }}"
                (click)="
                  $event.stopPropagation(); warningPopover.toggle($event)
                "
                [attr.aria-label]="
                  'WARNINGS.COUNT'
                    | translate
                      : { count: weekEvent.event.meta?.warnings?.length }
                "
                [title]="
                  weekEvent.event.meta?.warnings?.length + ' problema(s)'
                "
              ></span>
            </span>
          </div>

          <!-- Título truncado -->
          <span class="vc-event-card__title">
            {{ weekEvent.event.title }}
          </span>

          <!-- Popover con lista de warnings (fuera del header pero dentro del evento) -->
          <p-popover
            #warningPopover
            styleClass="vc-warning-popover"
            appendTo="body"
          >
            <div class="vc-warning-popover__content">
              <div class="vc-warning-popover__header">
                <i class="fas fa-exclamation-triangle"></i>
                <span>{{ "WARNINGS.TITLE" | translate }}</span>
              </div>
              <ul class="vc-warning-popover__list">
                <li
                  *ngFor="let warning of weekEvent.event.meta?.warnings"
                  class="vc-warning-popover__item severity-{{
                    warning.severity
                  }}"
                >
                  <i [class]="warning.icon"></i>
                  <span class="vc-warning-popover__label">{{
                    warning.label
                  }}</span>
                </li>
              </ul>
              <div class="vc-warning-popover__actions">
                <button
                  class="vc-warning-popover__btn vc-warning-popover__btn--primary"
                  (click)="
                    warningPopover.hide();
                    eventClicked.emit({ sourceEvent: $event })
                  "
                >
                  {{ "WARNINGS.VIEW_APPOINTMENT" | translate }}
                </button>
              </div>
            </div>
          </p-popover>

          <!-- Barra lateral derecha para warnings críticos/altos -->
          <div
            *ngIf="
              settings.display.showStatusIcons &&
              (weekEvent.event.meta?.maxSeverity === 'critical' ||
                weekEvent.event.meta?.maxSeverity === 'high')
            "
            class="vc-event-card__severity-bar severity-{{
              weekEvent.event.meta?.maxSeverity
            }}"
          ></div>
        </div>
      </ng-template>

      <ng-template
        #desktopHourSegmentTemplate
        let-segment="segment"
        let-segmentHeight="segmentHeight"
        let-isTimeLabel="isTimeLabel"
        let-daysInWeek="daysInWeek"
        let-locale="locale"
      >
        <div
          class="cal-hour-segment vc-calendar__segment"
          [style.height.px]="segmentHeight"
          [class.cal-hour-start]="segment.isStart"
          [class.cal-after-hour-start]="!segment.isStart"
          [ngClass]="segment.cssClass"
          (pointerdown)="onDesktopSegmentPointerDown($event, segment.date, segmentHeight)"
        >
          <div class="cal-time" *ngIf="isTimeLabel">
            {{
              segment.displayDate
                | calendarDate
                  : (daysInWeek === 1 ? "dayViewHour" : "weekViewHour")
                  : locale
            }}
          </div>
        </div>
      </ng-template>

      <div
        [ngSwitch]="view"
        class="vc-calendar__view"
      >
        <mwl-calendar-month-view
          [locale]="this.locale"
          *ngSwitchCase="CalendarView.Month"
          [viewDate]="viewDate"
          [events]="this.events"
          [weekStartsOn]="weekStartsOn"
          [refresh]="refresh"
          [activeDayIsOpen]="activeDayIsOpen"
          [excludeDays]="getExcludeDays()"
          (dayClicked)="changeDay($event.day.date)"
          (eventClicked)="openEvent($event.event)"
          (eventTimesChanged)="eventTimesChanged($event)"
        >
        </mwl-calendar-month-view>
        <mwl-calendar-week-view
          [locale]="this.locale"
          *ngSwitchCase="CalendarView.Week"
          [viewDate]="viewDate"
          [events]="this.events"
          [dayStartHour]="getDayStartHour()"
          [dayEndHour]="getDayEndHour()"
          [weekStartsOn]="weekStartsOn"
          [daysInWeek]="getDaysInWeek()"
          [refresh]="refresh"
          [excludeDays]="getExcludeDays()"
          [hourSegments]="1"
          [hourDuration]="this.getPrecision()"
          [hourSegmentTemplate]="desktopHourSegmentTemplate"
          (eventClicked)="openEvent($event.event)"
          (eventTimesChanged)="eventTimesChanged($event)"
          [eventTemplate]="customWeekEventTemplate"
        >
        </mwl-calendar-week-view>
        <div
          class="vc-calendar-day-grid"
          *ngSwitchCase="CalendarView.Day"
          [style.--calendar-day-columns]="calendars.length === 1 ? 1 : calendars.length === 2 ? 2 : 3"
        >
          <div
            class="vc-calendar-day-column"
            *ngFor="let calendar of calendars"
          >
            <div class="vc-calendar-day-column__title">
              {{ calendar.name }}
            </div>

            <ng-template
              #desktopDayHourSegmentTemplate
              let-segment="segment"
              let-segmentHeight="segmentHeight"
              let-isTimeLabel="isTimeLabel"
              let-locale="locale"
            >
              <div
                class="cal-hour-segment vc-calendar__segment"
                [style.height.px]="segmentHeight"
                [class.cal-hour-start]="segment.isStart"
                [class.cal-after-hour-start]="!segment.isStart"
                [ngClass]="segment.cssClass"
                (pointerdown)="onDesktopSegmentPointerDown($event, segment.date, segmentHeight, calendar)"
              >
                <div class="cal-time" *ngIf="isTimeLabel">
                  {{ segment.displayDate | calendarDate: "dayViewHour":locale }}
                </div>
              </div>
            </ng-template>

            <mwl-calendar-day-view
              [locale]="this.locale"
              [viewDate]="viewDate"
              [events]="this.getEventsByCalendar(calendar)"
              [dayStartHour]="getDayStartHour()"
              [dayEndHour]="getDayEndHour()"
              [refresh]="refresh"
              [hourSegments]="1"
              [hourDuration]="this.getPrecision()"
              [hourSegmentTemplate]="desktopDayHourSegmentTemplate"
              (eventClicked)="openEvent($event.event)"
              (eventTimesChanged)="eventTimesChanged($event)"
              [eventTemplate]="customWeekEventTemplate"
            >
            </mwl-calendar-day-view>
          </div>
        </div>
      </div>
    </div>

    <!-- Flecha derecha (solo desktop) -->
    <button
      class="vc-calendar__nav-arrow vc-calendar__nav-arrow--next"
      (click)="navigateNext()"
      aria-label="Período siguiente"
    >
      <i class="fas fa-chevron-right"></i>
    </button>
  </div>

  <p-dialog
    [(visible)]="selectionDialogVisible"
    [modal]="true"
    [closable]="false"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: 'min(92vw, 24rem)' }"
    styleClass="vc-calendar-selection-dialog"
    [header]="'CALENDAR.TIME_BLOCKS.SELECTION_TITLE' | translate"
  >
    <div class="vc-calendar-selection vc-calendar-selection--choice">
      <p class="vc-calendar-selection__range">{{ selectionRangeLabel }}</p>
    </div>

    <ng-template pTemplate="footer">
      <button
        pButton
        type="button"
        class="p-button-text"
        [label]="'COMMON.CANCEL' | translate"
        (click)="cancelSelection()"
      ></button>
      <button
        pButton
        type="button"
        class="p-button-outlined"
        [label]="'CALENDAR.TIME_BLOCKS.CREATE_APPOINTMENT' | translate"
        (click)="createAppointmentFromSelection()"
      ></button>
      <button
        pButton
        type="button"
        [label]="'CALENDAR.TIME_BLOCKS.BLOCK' | translate"
        (click)="openTimeBlockDialogFromSelection()"
      ></button>
    </ng-template>
  </p-dialog>

  <p-dialog
    [(visible)]="timeBlockDialogVisible"
    [modal]="true"
    [closable]="false"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: 'min(92vw, 32rem)' }"
    styleClass="vc-calendar-selection-dialog"
    [header]="'CALENDAR.TIME_BLOCKS.BLOCK' | translate"
  >
    <div class="vc-calendar-selection">
      <p class="vc-calendar-selection__range">{{ selectionRangeLabel }}</p>

      <div class="vc-calendar-selection__calendars" *ngIf="calendars.length > 1">
        <label>{{ 'CALENDAR.TIME_BLOCKS.CALENDARS' | translate }}</label>
        <div class="vc-calendar-selection__calendar-list">
          <label *ngFor="let calendar of calendars" class="vc-calendar-selection__calendar-option">
            <input
              type="checkbox"
              [checked]="isSelectionCalendarChecked(calendar)"
              (change)="toggleSelectionCalendar(calendar, $any($event.target).checked)"
            />
            <span>{{ calendar.name }}</span>
          </label>
        </div>
      </div>

      <div class="vc-calendar-selection__field">
        <label for="calendar-time-block-reason">{{ 'CALENDAR.TIME_BLOCKS.REASON' | translate }}</label>
        <input
          id="calendar-time-block-reason"
          type="text"
          [(ngModel)]="timeBlockReason"
          [placeholder]="'CALENDAR.TIME_BLOCKS.REASON_PLACEHOLDER' | translate"
        />
      </div>

      <div class="vc-calendar-selection__field">
        <label for="calendar-time-block-notes">{{ 'CALENDAR.TIME_BLOCKS.NOTES' | translate }}</label>
        <textarea
          id="calendar-time-block-notes"
          rows="3"
          [(ngModel)]="timeBlockNotes"
        ></textarea>
      </div>
    </div>

    <ng-template pTemplate="footer">
      <button
        pButton
        type="button"
        class="p-button-text"
        [label]="'COMMON.CANCEL' | translate"
        (click)="cancelSelection()"
      ></button>
      <button
        pButton
        type="button"
        [label]="'CALENDAR.TIME_BLOCKS.BLOCK' | translate"
        [disabled]="!selectedRangeCalendarIds.length"
        [loading]="savingTimeBlock"
        (click)="createTimeBlockFromSelection()"
      ></button>
    </ng-template>
  </p-dialog>

  <p-dialog
    [(visible)]="editTimeBlockDialogVisible"
    [modal]="true"
    [closable]="false"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: 'min(92vw, 32rem)' }"
    styleClass="vc-calendar-selection-dialog"
    [header]="'CALENDAR.TIME_BLOCKS.EDIT_TITLE' | translate"
  >
    <div class="vc-calendar-selection" *ngIf="editingTimeBlock">
      <p class="vc-calendar-selection__range">{{ editingTimeBlockRangeLabel }}</p>

      <div class="vc-calendar-selection__field" *ngIf="calendars.length > 1">
        <label for="calendar-time-block-edit-calendar">{{ 'CALENDAR.TIME_BLOCKS.CALENDAR' | translate }}</label>
        <select
          id="calendar-time-block-edit-calendar"
          [(ngModel)]="editingTimeBlockCalendarId"
        >
          <option *ngFor="let calendar of calendars" [ngValue]="calendar.id">
            {{ calendar.name }}
          </option>
        </select>
      </div>

      <div class="vc-calendar-selection__field">
        <label for="calendar-time-block-edit-reason">{{ 'CALENDAR.TIME_BLOCKS.REASON' | translate }}</label>
        <input
          id="calendar-time-block-edit-reason"
          type="text"
          [(ngModel)]="editingTimeBlockReason"
          [placeholder]="'CALENDAR.TIME_BLOCKS.REASON_PLACEHOLDER' | translate"
        />
      </div>

      <div class="vc-calendar-selection__field">
        <label for="calendar-time-block-edit-notes">{{ 'CALENDAR.TIME_BLOCKS.NOTES' | translate }}</label>
        <textarea
          id="calendar-time-block-edit-notes"
          rows="3"
          [(ngModel)]="editingTimeBlockNotes"
        ></textarea>
      </div>
    </div>

    <ng-template pTemplate="footer">
      <button
        pButton
        type="button"
        class="p-button-text p-button-danger"
        [label]="'COMMON.DELETE' | translate"
        [disabled]="!hasPermission('CALENDAR_TIME_BLOCKS.DELETE')"
        [loading]="deletingTimeBlock"
        (click)="confirmDeleteEditingTimeBlock()"
      ></button>
      <button
        pButton
        type="button"
        class="p-button-text"
        [label]="'COMMON.CANCEL' | translate"
        (click)="cancelTimeBlockEdition()"
      ></button>
      <button
        pButton
        type="button"
        [label]="'COMMON.SAVE' | translate"
        [disabled]="!editingTimeBlockCalendarId || !hasPermission('CALENDAR_TIME_BLOCKS.UPDATE')"
        [loading]="savingEditedTimeBlock"
        (click)="updateEditingTimeBlock()"
      ></button>
    </ng-template>
  </p-dialog>
</div>
